<template>
  <div class="railway-medium">
    <!-- Hero Section -->
    <section
      class="relative h-screen bg-cover bg-center flex items-center justify-center"
      style="background-image: url('/img/ns-hero-new.jpg');"
    >
      <!-- Content -->
      <div class="relative text-center text-white max-w-2xl mb-100 md:mb-0">
        <!-- Logo -->
        <div class="flex justify-center mb-4">
          <img src="/img/ns-logo.png" alt="Logo" class="max-w-[200px]" />
        </div>

        <!-- Title -->
        <h1 class="text-4xl md:text-7xl mb-3 font-black">
          NEW RELEASE FREEHOLD TOWNS
        </h1>

        <!-- Subtitle -->
        <!-- <p class="text-xl md:text-4xl mb-1 font-bold Gotham-Book">
          FROM $799,990
        </p> -->
        <p class="text-lg md:text-4xl font-black" style="font-family: 'Gotham-Bold';">
          COMING 2026
        </p>

        <!-- Button -->
        <a href="#register">
          <button
            class="mt-6 font-bold bg-[#E6003E] rounded-full hover:bg-red-700 transition duration-300 py-1 px-5 text-3xl"
          >
            REGISTER NOW
          </button>
        </a>
      </div>
    </section>

    <!-- Navbar Section -->
    <section id="navbar" class="bg-white py-4">
      <div class="container mx-auto flex justify-between items-center px-4">
        <!-- Logo -->
        <div class="flex items-center">
          <img
            src="/img/ns-logo.png"
            alt="New Seaton Logo"
            class="max-w-[150px]"
          />
        </div>
        <!-- Register Now Button -->
        <a href="#register">
          <div
            class="md:text-lg text-md leading-none font-bold bg-[#E6003E] rounded-full hover:bg-red-700 transition duration-300 py-1 md:w-[200px] w-[120px] text-white text-center"
          >
            REGISTER NOW
          </div>
        </a>
      </div>
    </section>

    <!-- New Section -->
    <section class="bg-[#113256] text-white pt-10 md:pt-32 pb-40 md:pb-60">
      <div class="container mx-auto px-4">
        <!-- Title -->
        <h2 class="text-3xl md:text-5xl font-bold mb-10">
          WELCOME TO PICKERING'S <span class="italic font-medium">PREMIER</span
          ><br />
          MASTER-PLANNED COMMUNITY
        </h2>

        <!-- Video and Description -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          <!-- Video -->
          <div>
            <div class="relative">
              <img
                src="/img/video-thumbnail.jpg"
                alt="Community Video"
                class="w-full"
              />
            </div>
          </div>
          <!-- Text -->
          <div>
            <h3 class="text-xl font-bold mb-4">
              FREEHOLD TOWNS FROM 1,450 TO 1,890 SQ.FT.
            </h3>
            <p class="mb-4 max-w-xl">
              Located just 30 minutes east of Toronto, New Seaton is a visionary
              new home community that is already home to hundreds of happy
              families.
            </p>
            <p class="max-w-xl">
              Be a part of this growing community that is changing the way
              people live, work, and play with schools, parks, trails, retail,
              and more built right in.
            </p>
          </div>
        </div>

        <!-- Features -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8 text-left ">
          <div class="flex items-center gap-4 py-3">
            <img src="/img/parks-icon.png" alt="Park Icon" class="w-[80px]" />
            <div class="text-center">
              <div class="text-7xl font-bold">42</div>
              <div class="text-sm font-bold mt-1">PARKS</div>
            </div>
          </div>
          <div class="flex items-center gap-4 py-3">
            <img src="/img/acres-icon.png" alt="Park Icon" class="w-[80px]" />
            <div class="text-center">
              <div class="text-7xl font-bold">3,750</div>
              <div class="text-sm font-bold mt-1">ACRES OF TRAILS</div>
            </div>
          </div>
          <div class="flex items-center gap-4 ">
            <img src="/img/school-icon.png" alt="Park Icon" class="w-[80px]" />
            <div class="text-center">
              <div class="text-7xl font-bold">3</div>
              <div class="text-sm font-bold mt-1">
                PROPOSED <br />
                ELEMENTARY SCHOOLS
              </div>
            </div>
          </div>
          <div class="flex items-center gap-4 py-3">
            <img src="/img/hwy-icon.png" alt="Park Icon" class="w-[80px]" />
            <div class="text-center">
              <div class="text-7xl font-bold">
                10 <span class="text-3xl">min</span>
              </div>
              <div class="text-sm font-bold mt-1">TO HWYS 401 & 407</div>
            </div>
          </div>
          <div class="flex items-center gap-4 py-3">
            <img
              src="/img/retailer-icon.png"
              alt="Park Icon"
              class="w-[80px]"
            />
            <div class="text-center">
              <div class="text-7xl font-bold">200+</div>
              <div class="text-sm font-bold mt-1">PROPOSED RETAILERS</div>
            </div>
          </div>
          <div class="flex items-center gap-4 py-3">
            <img src="/img/jobs-icon.png" alt="Park Icon" class="w-[80px]" />
            <div class="text-center">
              <div class="text-7xl font-bold">35K</div>
              <div class="text-sm font-bold mt-1">NEW JOBS</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      class="bg-white pt-12 sm:pt-32 pb-60 rounded-t-[60px] mt-[-120px] "
    >
      <img
        src="/img/ns-star.png"
        alt="Star"
        class="absolute w-[150px] right-[150px] z-0 hidden md:block"
      />
      <div class="container mx-auto px-4 px-4 relative z-10">
        <!-- Title -->
        <h2 class="text-3xl md:text-6xl font-black mb-6">
          TIMELESS TOWNHOMES,<br />
          TAILORED TO YOUR LIFESTYLE
        </h2>
        <p class="text-lg text-gray-700 mb-10 max-w-4xl">
          With so many styles and layouts to choose from, you'll find your
          perfect townhome at New Seaton. Browse our townhome collections now to
          learn more.
        </p>

        <!-- Collection Slider -->
        <div class="mb-12">
          <!-- Slider -->
          <slick
            v-if="collections.length > 0"
            ref="slick"
            :options="slickOptions"
          >
            <div
              v-for="(collection, index) in collections"
              :key="index"
              class="collection-slide"
            >
              <h3
                class="text-2xl mb-4 md:flex items-center font-black Gotham-Book"
              >
                <span class="Gotham-Bold mr-5">{{ collection.title }}</span>
                <span class="flex items-center text-gray-700 text-sm mt-0">
                  <img
                    src="/img/beds-icon.png"
                    alt="Bed Icon"
                    class="w-6 h-6 mr-2"
                  />
                  {{ collection.beds }} Bed
                  <img
                    src="/img/baths-icon.png"
                    alt="Bath Icon"
                    class="w-6 h-6 mx-2 ml-5"
                  />
                  {{ collection.baths }} Bath
                  <span class="ml-5 text-black Gotham-Bold min-w-[90px]">
                    UP TO {{ collection.size }} SQ. FT.
                  </span>
                </span>
              </h3>

              <div class="relative">
                <img
                  :src="collection.image"
                  :alt="collection.title"
                  class="w-full"
                />
                <div class="absolute bottom-[-60px] right-0 flex space-x-2">
                  <img
                    src="/img/ns-town-arrow.png"
                    alt="Arrow Left"
                    class="w-10 h-10 cursor-pointer mr-3 transform scale-x-[-1]"
                    @click="prevSlide"
                  />
                  <img
                    src="/img/ns-town-arrow.png"
                    alt="Arrow Right"
                    class="w-10 h-10 cursor-pointer"
                    @click="nextSlide"
                  />
                </div>
              </div>
              <p class="md:mt-4 mt-20 md:pr-52">
                {{ collection.description }}
              </p>
            </div>
          </slick>
        </div>

        <!-- Live With Everything in Reach -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-10 items-center mt-14">
          <div class="inline md:hidden">
            <img src="/img/decoration-logo.png" />
          </div>
          <!-- Text Content -->
          <div>
            <h2 class="text-3xl md:text-7xl font-black mb-6 max-w-lg">
              LIVE WITH EVERYTHING IN REACH
            </h2>
            <p class="text-gray-700 mb-6 max-w-xl">
              You're always just minutes away from everything you need in this
              ideal North Pickering location. At New Seaton, families will enjoy
              living near shopping, dining, protected greenspaces, golf courses,
              schools, essential services, transit, and best of all, Lake
              Ontario.
            </p>

            <!-- Amenities List -->
            <ul class="space-y-1">
              <li class="flex items-start gap-2">
                <img
                  src="/img/ns-list-icon.png"
                  alt="List Icon"
                  class="w-5 mt-1"
                />
                <span class="text-gray-700">
                  <strong>6 Mins to</strong> Pickering Golf Club
                </span>
              </li>
              <li class="flex items-start gap-2">
                <img
                  src="/img/ns-list-icon.png"
                  alt="List Icon"
                  class="w-5 mt-1"
                />
                <span class="text-gray-700">
                  <strong>6 Mins to</strong> Hwy. 407
                </span>
              </li>
              <li class="flex items-start gap-2">
                <img
                  src="/img/ns-list-icon.png"
                  alt="List Icon"
                  class="w-5 mt-1"
                />
                <span class="text-gray-700">
                  <strong>7 Mins to</strong> Seaton Trails
                </span>
              </li>
              <li class="flex items-start gap-2">
                <img
                  src="/img/ns-list-icon.png"
                  alt="List Icon"
                  class="w-5 mt-1"
                />
                <span class="text-gray-700">
                  <strong>8 Mins to</strong> Hwy. 401
                </span>
              </li>
              <li class="flex items-start gap-2">
                <img
                  src="/img/ns-list-icon.png"
                  alt="List Icon"
                  class="w-5 mt-1"
                />
                <span class="text-gray-700">
                  <strong>8 Mins to</strong> SmartCentres Pickering
                </span>
              </li>
              <li class="flex items-start gap-2">
                <img
                  src="/img/ns-list-icon.png"
                  alt="List Icon"
                  class="w-5 mt-1"
                />
                <span class="text-gray-700">
                  <strong>10 Mins to</strong> Greenwood Conservation Area
                </span>
              </li>
              <li class="flex items-start gap-2">
                <img
                  src="/img/ns-list-icon.png"
                  alt="List Icon"
                  class="w-5 mt-1"
                />
                <span class="text-gray-700">
                  <strong>11 Mins to</strong> Whitevale Golf Club
                </span>
              </li>
              <li class="flex items-start gap-2">
                <img
                  src="/img/ns-list-icon.png"
                  alt="List Icon"
                  class="w-5 mt-1"
                />
                <span class="text-gray-700">
                  <strong>11 Mins to</strong> Shops at Pickering City Centre
                </span>
              </li>
              <li class="flex items-start gap-2">
                <img
                  src="/img/ns-list-icon.png"
                  alt="List Icon"
                  class="w-5 mt-1"
                />
                <span class="text-gray-700">
                  <strong>14 Mins to</strong> Frenchman's Bay & Lake Ontario
                </span>
              </li>
              <li class="flex items-start gap-2">
                <img
                  src="/img/ns-list-icon.png"
                  alt="List Icon"
                  class="w-5 mt-1"
                />
                <span class="text-gray-700">
                  <strong>14 Mins or Less to</strong> Top-Rated Primary &
                  Secondary Schools
                </span>
              </li>
            </ul>
          </div>

          <!-- Image -->
          <div>
            <img
              src="/img/golf-course.jpg"
              alt="Pickering Golf Course"
              class="w-full rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>

    <section
      class="bg-cover bg-center-top bg-no-repeat bg-[url('/img/command-energy-bg.jpg')] text-white py-12 sm:py-32 rounded-t-[60px] mt-[-190px] sm:mt-[-120px]"
    >
      <div class="container mx-auto px-4">
        <!-- Title -->
        <h2 class="text-3xl md:text-7xl font-black mb-20">
          GET MORE IN A BROOKFIELD<br />
          RESIDENTIAL HOME
        </h2>

        <!-- myCommand Section -->
        <div
          class="flex flex-col-reverse md:flex-row gap-10 items-center mb-16"
        >
          <!-- Image -->
          <div class="w-full md:w-1/2">
            <img
              src="/img/mycommand-family.jpg"
              alt="Family using myCommand"
              class="w-full"
            />
          </div>
          <!-- Content -->
          <div class="w-full md:w-1/2">
            <h3 class="text-2xl font-bold mb-4 flex items-center">
              <img
                src="/img/mycommand-icon.png"
                alt="myCommand Icon"
                class="md:max-w-[400px] mr-2"
              />
            </h3>
            <p class="text-lg mb-6 max-w-xl">
              With myCommand technology, control home automation with your
              favorite smart devices from anywhere, at any time.
            </p>
            <p class="ml-6 font-bold">
              VIDEO DOORBELL
            </p>
            <ul class="max-w-xl">
              <li class="flex items-start gap-4">
                <span class="text-[#00D1FF] text-2xl">•</span>
                <span>
                  Residential exterior door grip set with KEYLESS ENTRY
                  technology and custom builder logo key
                </span>
              </li>
              <li class="flex items-start gap-4">
                <span class="text-[#00D1FF] text-2xl">•</span>
                <span>Smart Home Thermostat</span>
              </li>
              <li class="flex items-start gap-4">
                <span class="text-[#00D1FF] text-2xl">•</span>
                <span>Smart Home Hub</span>
              </li>
              <li class="flex items-start gap-4">
                <span class="text-[#00D1FF] text-2xl">•</span>
                <span>Leak Sensor</span>
              </li>
              <li class="flex items-start gap-4">
                <span class="text-[#00D1FF] text-2xl">•</span>
                <span>Smart Switch for exterior lights and Foyer</span>
              </li>
              <li class="flex items-start gap-4">
                <span class="text-[#00D1FF] text-2xl">•</span>
                <span>HVAC Performance Monitoring</span>
              </li>
              <li class="flex items-start gap-4">
                <span class="text-[#00D1FF] text-2xl">•</span>
                <span>
                  Two USB outlet combination electrical receptacles
                </span>
              </li>
              <li class="flex items-start gap-4">
                <span class="text-[#00D1FF] text-2xl">•</span>
                <span>
                  One internet service outlet in Family Room finished with two
                  ports plate including two Cat6
                </span>
              </li>
              <li class="flex items-start gap-4">
                <span class="text-[#00D1FF] text-2xl">•</span>
                <span>
                  Two Cat6 data outlets with finished plate for IPTV
                </span>
              </li>
            </ul>
          </div>
        </div>

        <!-- myEnergy Section -->
        <div
          class="flex flex-col md:flex-row gap-10 items-center mt-3 md:mt-32"
        >
          <!-- Content -->
          <div class="w-full md:w-1/2">
            <h3 class="text-2xl font-bold mb-4 flex items-center">
              <img
                src="/img/myenergy-icon.png"
                alt="myEnergy Icon"
                class="max-w-[300px] mr-2 mb-3"
              />
            </h3>
            <p class="text-lg mb-6 max-w-xl">
              Newbrook homes are built with sustainable materials and designed
              for the highest levels of performance to help the environment, and
              your wallet.
            </p>
            <ul class=" max-w-xl">
              <li class="flex items-start gap-4">
                <span class="text-[#00D1FF] text-2xl">•</span>
                <span>High efficiency two-stage furnace with ECM motor</span>
              </li>
              <li class="flex items-start gap-4">
                <span class="text-[#00D1FF] text-2xl">•</span>
                <span
                  >High efficiency condensing boiler and heat exchanger</span
                >
              </li>
              <li class="flex items-start gap-4">
                <span class="text-[#00D1FF] text-2xl">•</span>
                <span>
                  Energy Recovery Ventilator System (standard ERV)
                </span>
              </li>
              <li class="flex items-start gap-4">
                <span class="text-[#00D1FF] text-2xl">•</span>
                <span>High efficiency tankless hot water heater</span>
              </li>
              <li class="flex items-start gap-4">
                <span class="text-[#00D1FF] text-2xl">•</span>
                <span>High efficiency hot water tank</span>
              </li>
              <li class="flex items-start gap-4">
                <span class="text-[#00D1FF] text-2xl">•</span>
                <span>Water-conserving toilets</span>
              </li>
              <li class="flex items-start gap-4">
                <span class="text-[#00D1FF] text-2xl">•</span>
                <span>Drain water heat-recovery unit</span>
              </li>
              <li class="flex items-start gap-4">
                <span class="text-[#00D1FF] text-2xl">•</span>
                <span>
                  Foam insulation around all door and window surrounds and at
                  floor of habitable rooms located over garage spaces
                </span>
              </li>
              <li class="flex items-start gap-4">
                <span class="text-[#00D1FF] text-2xl">•</span>
                <span>All windows are factory-sealed Low E Argon</span>
              </li>
              <li class="flex items-start gap-4">
                <span class="text-[#00D1FF] text-2xl">•</span>
                <span>
                  Performance of exterior wall construction exceeds industry
                  standard
                </span>
              </li>
              <li class="flex items-start gap-4">
                <span class="text-[#00D1FF] text-2xl">•</span>
                <span>
                  Professional testing by third-party Energy Rating Consultants
                </span>
              </li>
            </ul>
          </div>
          <!-- Image -->
          <div class="w-full md:w-1/2">
            <img
              src="/img/myenergy-kitchen.jpg"
              alt="Family using myEnergy features"
              class="w-full rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="bg-white py-14 md:py-32">
      <div class="container mx-auto px-4">
        <!-- Top Section -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-10 items-center mb-16">
          <!-- Left Content -->
          <div>
            <h2 class="text-4xl md:text-7xl font-black mb-6">
              ABOUT<br />
              BROOKFIELD<br />
              RESIDENTIAL
            </h2>
            <p class="text-lg  max-w-xl">
              Brookfield Residential is a leading North American new home
              builder and land developer with one goal in mind – to create the
              Best Places to Call Home. From the development of award-winning
              master-planned communities over the past 65 years, to the design
              and construction of premier homes, Brookfield Residential is
              committed to cultivating exceptional experiences for each and
              every homeowner.
            </p>
          </div>

          <!-- Right Content -->
          <div class="flex justify-end">
            <img
              src="/img/ns-bf-logo-blue.png"
              alt="Brookfield Logo"
              class="md:max-w-[400px]"
            />
          </div>
        </div>

        <!-- Awards Section -->
        <div class="mb-2 mt-10">
          <h3 class="text-2xl md:text-5xl ">
            AWARD WINNING CUSTOMER CARE SINCE 1956
          </h3>
        </div>

        <!-- Awards Grid -->
        <img
          src="/img/bf-awards.png"
          alt="Awards"
          class="w-full md:p-4 hidden md:block"
        />
        <img
          src="/img/bf-awards-1.png"
          alt="Awards"
          class="w-full md:p-4 blaock md:hidden"
        />
      </div>
    </section>

    <section id="register" class="bg-[#113256] text-white py-10 md:py-20">
      <div class="container mx-auto px-4">
        <!-- Header -->
        <div class="mb-8">
          <h2 class="text-3xl md:text-6xl font-black mb-4 text-left">
            REGISTER
          </h2>
          <p class="text-lg text-left max-w-5xl">
            Sign up and receive access to floor plans, home designs, community
            plans, lot pricing, as well as priority updates on upcoming events
            and incentives.
          </p>
          <!-- <p class="text-lg font-bold mt-4 text-left">* Mandatory Fields</p> -->
        </div>

        <!-- Form -->
        <form class="space-y-6" style="display: none">
          <!-- Row 1 -->
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <input
              type="text"
              placeholder="FIRST NAME*"
              class="w-full p-3 border border-gray-300 text-black placeholder-black"
              required
            />
            <input
              type="text"
              placeholder="LAST NAME*"
              class="w-full p-3 border border-gray-300 text-black placeholder-black"
              required
            />
            <input
              type="email"
              placeholder="EMAIL*"
              class="w-full p-3 border border-gray-300 text-black placeholder-black"
              required
            />
          </div>

          <!-- Row 2 -->
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <input
              type="text"
              placeholder="PHONE NUMBER"
              class="w-full p-3 border border-gray-300 text-black placeholder-black"
            />
            <input
              type="text"
              placeholder="CITY"
              class="w-full p-3 border border-gray-300 text-black placeholder-black"
            />
            <input
              type="text"
              placeholder="POSTAL CODE*"
              class="w-full p-3 border border-gray-300 text-black placeholder-black"
              required
            />
          </div>

          <!-- Row 3 -->
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <!-- Dropdown with Plus Icon -->
            <div class="relative">
              <select
                class="w-full p-3 border border-gray-300 text-black placeholder-black appearance-none"
                required
              >
                <option value="" disabled selected>
                  HOW DID YOU HEAR ABOUT US?
                </option>
                <option value="online">Online</option>
                <option value="friend">Friend</option>
                <option value="ad">Advertisement</option>
              </select>
              <span
                class="absolute right-4 top-1/2 transform -translate-y-1/2 text-black font-light text-4xl"
              >
                +
              </span>
            </div>

            <!-- Realtor Radio Buttons -->
            <div class="md:flex items-center md:space-x-4 md:ml-5 mt-2">
              <label class="text-lg font-bold min-w-[200px]"
                >ARE YOU A REALTOR?</label
              >
              <div class="flex items-center space-x-10 md:pl-20">
                <label class="flex items-center">
                  <input
                    type="radio"
                    name="realtor"
                    value="yes"
                    class="form-radio text-[#E6003E] border-gray-300"
                    required
                  />
                  <span class="ml-1">YES</span>
                </label>
                <label class="flex items-center">
                  <input
                    type="radio"
                    name="realtor"
                    value="no"
                    class="form-radio text-[#E6003E] border-gray-300"
                    required
                  />
                  <span class="ml-1">NO</span>
                </label>
              </div>
            </div>
          </div>

          <!-- Newsletter Checkbox with Submit Button -->
          <div
            class="flex flex-col md:flex-row items-start md:items-center gap-4"
          >
            <div class="flex items-center space-x-2 flex-1">
              <div>
                <input
                  type="checkbox"
                  class="form-checkbox text-[#E6003E] border-gray-300"
                />
                <label class="text-lg mt-2 md:ml-2">
                  Sign up for our monthly newsletter. You can unsubscribe at any
                  time.
                </label>
                <!-- Terms -->
                <p class="text-[8px] max-w-md md:ml-7">
                  By completing this Registration Form for New Seaton, I
                  expressly provide my consent to receive electronic messages
                  from New Seaton, retroactively, today and in the future and
                  for any projects by the builders of New Seaton. I understand
                  that I may withdraw my consent by unsubscribing at any time.
                </p>
              </div>
            </div>
            <button
              type="submit"
              class="bg-[#E6003E] text-white font-black py-2 rounded-full min-w-[300px] hover:bg-red-700 transition duration-300 text-2xl"
            >
              SUBMIT
            </button>
          </div>
        </form>

        <div id="hubspotForm"></div>
      </div>
    </section>

    <section class="bg-[#222020] text-white py-20">
      <div class="container mx-auto px-4">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-10 Gotham-Book">
          <!-- Left Content -->
          <div>
            <h3 class="text-xl font-bold uppercase Gotham-Bold">
              Presentation Centre
            </h3>
            <p class="text-lg text-yellow-400 mb-10">
              <a
                href="https://maps.app.goo.gl/x7hNg4PrAECgUWGC8"
                target="_blank"
                class="hover:underline"
                >2820 Sideline 26, Pickering,
                <span class="inline md:hidden"><br /></span>Ontario L0H 1J0</a
              >
            </p>
            <p class="text-lg text-yellow-400 mb-2">By Appointment Only</p>
            <p class="text-lg text-yellow-400 mb-4 Gotham-Bold">
              <a
                href="mailto:newseaton@brookfieldrp.com"
                class="hover:underline"
                >newseaton@brookfieldrp.com</a
              ><br />
              <a href="tel:647-371-5607" class="hover:underline"
                >647-371-5607</a
              >
            </p>
            <p class="text-xs text-white mb-6 max-w-xl">
              Prices, specifications and promotions are subject to change
              without notice. Renderings are artists’ concept. See Community
              Ambassador for details. E & O.E. Copyright © 2026 Brookfield
              Residential Properties ULC. Privacy Policy | Terms & Conditions
            </p>
            <div class="flex items-center space-x-4">
              <a
                href="https://www.instagram.com/explore/locations/489621741391384/new-seaton/"
                target="_blank"
                rel="noopener noreferrer"
                class="text-yellow-400 text-xl"
              >
                <i class="fab fa-instagram"></i>
              </a>
            </div>
          </div>

          <!-- Right Content -->
          <div class="flex justify-end items-center">
            <div class="flex flex-col items-end">
              <a
                href="https://maps.app.goo.gl/x7hNg4PrAECgUWGC8"
                target="_blank"
              >
                <img
                  src="/img/bf-ns-map.png"
                  alt="Map to Presentation Centre"
                  class="w-full max-w-md"
              /></a>

              <img
                src="/img/bf-ns-logo-white.png"
                alt="Brookfield Logo"
                class="max-w-[180px] mt-4 mr-10"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Slick from "vue-slick";

export default {
  layout: "blank",
  components: {
    Slick
  },
  data() {
    return {
      collections: [
        {
          title: "TRADITIONAL COLLECTION",
          beds: "3-4",
          baths: "2.5",
          size: "1,850",
          image: "/img/traditional-collection-model.jpg",
          description:
            "New Seaton offers a refined collection of premium Traditional Townhome designs up to 1,850 sq. ft. The Traditional Collection showcases classic architecture, wide interior spaces, and premium design elements for a grand townhome lifestyle. Electric fireplaces, optional cathedral ceilings, and large primary walk-in closets are just some of the many elevated additions these refined townhomes offer. There’s never been a better time to call New Seaton home."
        },
        {
          title: "URBAN COLLECTION",
          beds: "3",
          baths: "3",
          size: "1,890",
          image: "/img/urban-collection-model.jpg",
          description:
            "The Urban Collection combines big-city style with long sightlines and raised terraces to offer a unique townhome experience. Generous 3-bedroom and 3-bathroom plans feature convenient design elements like 2nd floor Laundry Rooms, optional Powder Rooms, and multiple walk-in closets that families will surely enjoy. With a range of floor plan options and 2 modern elevations to choose from, there’s never been a better time to call New Seaton home."
        }
      ],
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        infinite: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    };
  },
  methods: {
    nextSlide() {
      this.$refs.slick.next();
    },
    prevSlide() {
      this.$refs.slick.prev();
    },
    handleScroll() {
      const navbar = document.getElementById("navbar");
      const navbarOffsetTop = navbar.offsetTop;

      if (window.scrollY > navbarOffsetTop) {
        // Add the fixed class if scrolled below
        navbar.classList.add("fixed-navbar");
      } else {
        // Remove the fixed class if scrolled above
        navbar.classList.remove("fixed-navbar");
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    // Add Tailwind CSS CDN dynamically
    if (!document.querySelector("#tailwindcdn-script")) {
      const script = document.createElement("script");
      script.id = "tailwindcdn-script";
      script.src = "https://cdn.tailwindcss.com";
      document.head.appendChild(script);
    }

    //hubspot form
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/v2.js";
    document.body.appendChild(script);
    script.addEventListener("load", () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "na1",
          portalId: "3390596",
          formId: "5d989582-6e88-4965-b095-93f6fe533beb",
          target: "#hubspotForm"
        });
      }
    });
  },
  beforeDestroy() {
    // Clean up the event listener
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped lang="scss">
.fixed-navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 50;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
</style>
